// FIXME: Fix this the next time the file is edited.
// @ts-expect-error TS(6133): 'jsx' is declared but its value is never read.
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { css, jsx } from "@emotion/react";
import * as React from "react";

import { Icon, IconsEnum } from "components/icon";
import { IApplicationIcons } from "store/entities/applications";

import { DefaultIntegration } from "../constants";
import { isDefaultIntegration } from "../helpers";

const appIconCss = css`
  width: 45px;
  height: 45px;
  object-fit: contain;
`;

interface IProps {
  id: string;
  name: string;
  icons?: IApplicationIcons;
}

const ApplicationIcon: React.FC<IProps> = ({ id, name, icons }) => {
  const iconSrc = icons?.small || icons?.large;

  if (isDefaultIntegration(id)) {
    if (id === DefaultIntegration.Zapier) {
      return <Icon name={IconsEnum.Zapier} width="45px" height="45px" />;
    }

    if (id === DefaultIntegration.LiveChat) {
      return <Icon name={IconsEnum.LiveChatLarge} width="45px" height="45px" />;
    }
  }

  if (iconSrc) {
    return <img src={iconSrc} alt={icons?.title || name} css={appIconCss} />;
  }

  return <Icon name={IconsEnum.AppLogoFallback} width="45px" height="45px" />;
};

export default ApplicationIcon;
